import React from 'react'
import { CardContainer } from '../../../websiteBuilder/WebsiteConfiguration/SettingsComponents/CookieConsent'
import TooltipIcon from '../../../../assets/icons/Tooltip'
import StyledText from '../../../../components/StyledComponents/StyledText'
import { useTheme } from '../../../../middleware/ThemeContext'

interface AlertNoticeProps {
    message: string;
    noMargin?: boolean;
}

const AlertNotice:React.FC<AlertNoticeProps> = ({ message, noMargin }) => {
    const {theme} = useTheme();
  return (
    <CardContainer style={{ padding: '15px', marginBottom: '18px', margin: noMargin ? '0' : '0 0 18px 0' }} theme={theme}>
        <div className='d-flex align-items-start gap-2'>
            <TooltipIcon color='rgba(245, 158, 11, 1)' size={18} style={{ marginTop: '1px' }} />
            <StyledText fontSize={'14px'} fontWeight={500} textColor={theme.CorporateTheme.colors.headerColor} lineHeight='22px'>{message}</StyledText>
        </div>
    </CardContainer >
  )
}

export default AlertNotice